module.exports = __webpack_public_path__ + "media/images/icons/ccicon-a7e55b7758e677d87c85d4692062b924.svg";